import { env } from '@/env'

const cognitoHomolog = {
  appClientId: env.REACT_APP_COGNITO_HOMOLOG_APP_CLIENT_ID,
  identityPoolId: '',
  region: env.REACT_APP_AWS_REGION,
  userPoolId: env.REACT_APP_COGNITO_HOMOLOG_USER_POOL_ID,
}

const cognitoProd = {
  appClientId: env.REACT_APP_COGNITO_PRODUCTION_APP_CLIENT_ID,
  identityPoolId: '',
  region: '',
  userPoolId: env.REACT_APP_COGNITO_PRODUCTION_USER_POOL_ID,
}

export const AWS = {
  api: {
    test: {
      url: env.REACT_APP_API_TEST_URL,
    },
  },
  cognito:
    env.REACT_APP_ENV === 'production'
      ? cognitoProd
      : env.REACT_APP_ENV === 'internal'
        ? cognitoProd
        : cognitoHomolog,
}
